import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBX3tkzQRsjInVnr1JckCu4ku1MqIQrg88",
  authDomain: "afanjou-7181c.firebaseapp.com",
  projectId: "afanjou-7181c",
  storageBucket: "afanjou-7181c.firebasestorage.app",
  messagingSenderId: "865274314043",
  appId: "1:865274314043:web:3c211fd2454f3251b94b1e",
  measurementId: "G-43L7D04FCQ"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);